
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teachers/search",
      function () {
        return require("private-next-pages/teachers/search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/teachers/search"])
      });
    }
  